<template>
  <BModal
    v-model="uiStore.showRegistrationNotCompleteModal"
    title="Registration not complete"
    centered
    @hidden="close"
  >
    <div class="modal-body p-0">
      <div class="row">
        <div class="col-12">
          <p>
            <b
              >Before buying or importing a license, you need to complete your
              registration.</b
            >
          </p>
          <p v-if="!userStore.isUserDataComplete">
            Please complete your
            <StoreLink
              :href="'/users/' + userStore.authUserUuid + '/profile'"
              @click="close"
              >user profile</StoreLink
            >
            to continue.
          </p>
          <p
            v-if="
              companyStore.userHasCompany && !userStore.isCompanyDataComplete
            "
          >
            <span v-if="userStore.isCompanyAdmin">
              Please complete your
              <StoreLink
                :href="
                  '/users/' +
                  userStore.authUserUuid +
                  '/company/' +
                  companyStore.userCompany?.id +
                  '/address'
                "
                @click="close"
                >company profile</StoreLink
              >.
            </span>
            <span v-else>
              The admin of your company has to complete the
              <StoreLink
                :href="'/users/' + userStore.authUserUuid + '/company'"
                @click="close"
                >company profile</StoreLink
              >.
            </span>
          </p>
          <p v-else-if="!companyStore.userHasCompany">
            Please complete your
            <StoreLink
              :href="
                '/users/' + userStore.authUserUuid + '/company-registration'
              "
              @click="close"
              >company registration</StoreLink
            >
            to continue.
          </p>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="d-flex justify-content-end gap-2">
        <StoreButton @click="close"> Close </StoreButton>
      </div>
    </template>
  </BModal>
</template>

<script lang="ts" setup>
import { BModal } from "bootstrap-vue-next";
import { useUserStore } from "~/stores/userstore";
import { useUiStore } from "~/stores/ui/uistore";
import StoreButton from "~/components/shared/buttons/StoreButton.vue";
import StoreLink from "~/components/shared/buttons/StoreLink.vue";

function close() {
  uiStore.showRegistrationNotCompleteModal = false;
}

const userStore = useUserStore();
const companyStore = useCompanyStore();
const uiStore = useUiStore();
</script>
<!-- scoped - does not work here because the bootstrap modal uses teleports -->
<style lang="scss"></style>
